import { getRegularPolygonPoints } from '../../../../../utilities/ShapeGenerators';
import getSides from './sides';

const getPoints = shape => getRegularPolygonPoints(getSides(shape), shape.get('width'), shape.get('height'));

export default getPoints;
